import { useEffect, useState } from 'react';

/**
 * Top-of-app banner shown while the device reports offline.
 *
 * Canonical doc note: navigator.onLine is flaky on first launch in WKWebView,
 * so we wait 1s before trusting an "offline" initial value. The 'online' /
 * 'offline' events themselves are correct.
 */
export default function OfflineBanner() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setOffline(navigator.onLine === false);
    }, 1000);

    const handleOnline = () => setOffline(false);
    const handleOffline = () => setOffline(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      clearTimeout(initialDelay);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="border-b border-zinc-500/30 bg-zinc-700 text-white px-4 py-2 text-xs text-center">
      You're offline — sessions are saved locally and will sync when you reconnect.
    </div>
  );
}
